// extracted by mini-css-extract-plugin
module.exports = {"disableDeal":"styles_disableDeal__vSB0l","enableDeal":"styles_enableDeal__18oow"};